import React from "react";
import { motion } from "framer-motion";
import { MaskedWords, Reveal } from "../components/Reveal";
import { PROJECTS } from "../data/content";
import { Spiral } from "../components/Scribbles";

export default function Projects() {
  return (
    <div className="px-5 md:px-10 pt-32 pb-28" data-testid="projects-page">
      <header className="max-w-5xl mb-20 flex items-end justify-between">
        <div>
          <p className="font-handwritten text-3xl text-terracotta mb-4 rotate-[-2deg]">selected works</p>
          <h1 className="font-serif font-light text-6xl md:text-8xl uppercase tracking-tighter text-ink leading-none">
            <MaskedWords text="Projects" />
          </h1>
        </div>
        <Spiral size={70} className="hidden md:block mb-4" />
      </header>

      <div className="space-y-28 max-w-6xl">
        {PROJECTS.map((project, i) => (
          <Reveal key={project.id} delay={0.05}>
            <div
              className={`grid md:grid-cols-12 gap-8 items-center ${
                i % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
              data-testid={`project-${project.id}`}
            >
              {/* Clipped framed image */}
              <div className="md:col-span-7 [direction:ltr]">
                <div className="border-2 border-ink bg-sand p-4 md:p-8 overflow-hidden">
                  <div className="overflow-hidden">
                    <motion.img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-[320px] md:h-[440px] object-cover grayscale-[15%] hover:grayscale-0 hover:scale-105 transition-all duration-700 ease-out"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>

              {/* Meta */}
              <div className="md:col-span-5 [direction:ltr]">
                <span className="font-serif text-7xl md:text-8xl text-ink/10">{project.id}</span>
                <h2 className="font-serif text-4xl md:text-5xl text-ink -mt-6">{project.title}</h2>
                <div className="flex items-center gap-3 mt-3 text-xs uppercase tracking-widest text-terracotta">
                  <span>{project.category}</span>
                  <span className="text-ink/40">/</span>
                  <span>{project.year}</span>
                </div>
                <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed">
                  {project.description}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
